import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { slugify } from './utils/slugify';
import { useContent } from '../content/ContentProvider';

export const RadialMenu: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const { skillSlug } = useParams<{ skillSlug: string }>();
    const { skillPage } = useContent();

    const skills = Object.keys(skillPage.skills);
    const currentIndex = skills.findIndex(skill => slugify(skill) === skillSlug);

    // Gestisci il caso speciale per il primo servizio
    const prevSkill = currentIndex === 0 
        ? skills[skills.length - 1]  // Se siamo al primo, mostra l'ultimo
        : skills[(currentIndex - 1) % skills.length];
        
    const nextSkill = skills[(currentIndex + 1) % skills.length];
    const oppositeSkill = skills[(currentIndex + 2) % skills.length];

    const handleSkillClick = (skill: string) => {
        navigate(`/skill/${slugify(skill)}`);
        setIsOpen(false);
        window.scrollTo(0, 0);
    };

    const getIconPath = (index: number) => {
        const icons = [
            "/artificial-intelligence.png",
            "/language.png",
            "/recommended.png",
            "/collaboration.png",
        ];
        // Gestisci l'indice negativo per il primo servizio
        if (index < 0) index = icons.length - 1;
        return icons[index % icons.length];
    };

    const overlayClass = isOpen
        ? "fixed inset-0 bg-black bg-opacity-30 transition-opacity duration-300 opacity-100"
        : "fixed inset-0 bg-black bg-opacity-30 transition-opacity duration-300 opacity-0 pointer-events-none";

    return (
        <>
            <div className={overlayClass} onClick={() => setIsOpen(false)} />

            <div className="fixed bottom-8 right-8 z-50">
                <div className={`relative ${isOpen ? 'pointer-events-auto' : 'pointer-events-none'}`}>
                    <button
                        onClick={() => handleSkillClick(prevSkill)}
                        className={`absolute w-12 h-12 rounded-full bg-hot-pink text-white flex items-center justify-center transform transition-all duration-300 shadow-lg hover:scale-110 hover:bg-purple
              ${isOpen ? '-translate-y-20 opacity-100' : 'translate-y-0 opacity-0'}`}
                    >
                        <img 
                            src={getIconPath(currentIndex === 0 ? skills.length - 1 : currentIndex - 1)} 
                            alt={prevSkill} 
                            className="w-6 h-6 object-contain" 
                        />
                    </button>

                    <button
                        onClick={() => handleSkillClick(oppositeSkill)}
                        className={`absolute w-12 h-12 rounded-full bg-hot-pink text-white flex items-center justify-center transform transition-all duration-300 shadow-lg hover:scale-110 hover:bg-purple
              ${isOpen ? '-translate-x-20 opacity-100' : 'translate-x-0 opacity-0'}`}
                    >
                        <img src={getIconPath(currentIndex + 2)} alt={oppositeSkill} className="w-6 h-6 object-contain" />
                    </button>

                    <button
                        onClick={() => handleSkillClick(nextSkill)}
                        className={`absolute w-12 h-12 rounded-full bg-hot-pink text-white flex items-center justify-center transform transition-all duration-300 shadow-lg hover:scale-110 hover:bg-purple
              ${isOpen ? '-translate-x-20 -translate-y-20 opacity-100' : 'translate-x-0 translate-y-0 opacity-0'}`}
                    >
                        <img src={getIconPath(currentIndex + 1)} alt={nextSkill} className="w-6 h-6 object-contain" />
                    </button>
                </div>

                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className={`w-12 h-12 rounded-full bg-hot-pink text-white flex items-center justify-center shadow-lg hover:bg-purple transition-all duration-300 relative z-10 group ${isOpen ? 'rotate-180 scale-110' : ''
                        } transform`}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                        />
                    </svg>
                </button>
            </div>
        </>
    );
};